// Sdelka faoliyati (DealActivity, type: 'communication') uchun umumiy
// kontakt turi/natija belgilari — DealDetailPage'dagi kommunikatsiya
// composer va CompleteTaskModal bir xil ro'yxat/ranglardan foydalanadi.
import { Phone, MessageSquare, Calendar } from 'lucide-react';

export const CONTACT_TYPE_ICON = { call: Phone, message: MessageSquare, meeting: Calendar };

export const OUTCOME_COLOR = {
  interested: 'bg-emerald-50 text-emerald-700',
  thinking:   'bg-amber-50 text-amber-700',
  declined:   'bg-red-50 text-red-600',
  no_answer:  'bg-surface-100 text-ink-tertiary',
  other:      'bg-surface-100 text-ink-secondary',
};

export const OUTCOME_TAGS = ['interested', 'thinking', 'declined', 'no_answer', 'other'];

export const outcomeLabelKey = (tag) =>
  `deals.outcome${tag.charAt(0).toUpperCase()}${tag.slice(1).replace(/_([a-z])/g, (_, c) => c.toUpperCase())}`;

export const contactTypeLabelKey = (ct) =>
  `deals.contactType${ct?.charAt(0).toUpperCase()}${ct?.slice(1)}`;
